export type IconName =
    | 'arrow_downward'
    | 'arrow_upward'
    | 'swap_vert'
    | 'first_page'
    | 'last_page'
    | 'chevron_left'
    | 'chevron_right'
    | 'keyboard_arrow_down'
    | 'settings'
    | 'search'
    | 'close'
    | 'more_vert'
    | 'filter_alt'
    | 'refresh'
    | 'inbox'
    | 'error';

export interface IconProps {
    name: IconName;
    size?: 'small' | 'medium' | 'large';
    className?: string;
}

export function Icon(props: IconProps): JSX.Element {
    const { name, size = 'small', className } = props;
    const classes = ['guardian-icon', `guardian-icon--${size}`, className]
        .filter(Boolean)
        .join(' ');
    return (
        <span aria-hidden="true" className={classes}>
            {name}
        </span>
    );
}
